import Tezaurus from '../model/Tezaurus';
import { ClientStatus } from '../model/ClientStatus';
import { useClientFetch } from '../context/ClientStatusContext';
import { fetchTezaurusDetail } from '../client/tezaurus/tezaurusDetailClient';

interface ReturnType {
  tezaurus: Tezaurus;
  tezaurusStatus: ClientStatus;
  reloadTezaurus
}

export default (uuid = '', shouldFetch = true): ReturnType => {
  const {
    data: tezaurus,
    status: tezaurusStatus,
    refetch: reloadTezaurus,
  } = useClientFetch(
    fetchTezaurusDetail,
    [uuid, shouldFetch],
    [],
  );
  return <ReturnType> {
    tezaurus,
    tezaurusStatus,
    reloadTezaurus,
  };
};
